import { Box, Button,  Stack,  VStack } from "@chakra-ui/react";
import React from "react";
import { FaAngleDown } from "react-icons/fa6";
import './Searching.component.css'
const Filtering = () => {
  return (
    <VStack w="100%" flexDirection="row">
      {/* desktop version */}
        <Stack  className="desktop-version" w="100%" flexDirection="row">
        <Box
        gap="0"
        w="50%"
        display="flex"
        flexDirection={"row"}
        alignItems="center"
        justifyContent="flex-start"
      >
        <Button
          fontFamily="'Roboto', sans-serif"
          fontSize="18px"
          fontWeight="500"
          bg="rgba(96, 31, 235, 1)"
          borderRadius="10px"
          padding="12px 30px"
          color="rgba(255, 255, 255, 1)"
          boxShadow={"0px 15px 17px 0px rgba(96, 31, 235, 0.17)"}
        >
          All sessions
        </Button>

        <Button
          fontFamily="'Roboto', sans-serif"
          fontSize="18px"
          fontWeight="500"
          bg="rgba(255, 255, 255, 1)"
          marginX="20px"
          borderRadius="10px"
          padding="12px 30px"
          transition="0.3s"
          color="rgba(0, 0, 0, 1)"
          boxShadow={"0px 15px 17px 0px rgba(96, 31, 235, 0.17)"}
          _hover={{
            backgroundColor: "rgba(96, 31, 235, 1)",
            color: "rgba(255, 255, 255, 1)",
          }}
        >
          FRX Academic
        </Button>

        <Button
          fontFamily="'Roboto', sans-serif"
          fontSize="18px"
          fontWeight="500"
          bg="rgba(255, 255, 255, 1)"
          marginX="20px"
          borderRadius="10px"
          padding="12px 30px"
          transition="0.3s"
          color="rgba(0, 0, 0, 1)"
          boxShadow={"0px 15px 17px 0px rgba(96, 31, 235, 0.17)"}
          _hover={{
            backgroundColor: "rgba(96, 31, 235, 1)",
            color: "rgba(255, 255, 255, 1)",
          }}
        >
          FRX Pro
        </Button>
      </Box>
      <Box
        gap="0"
        w="50%"
        display="flex"
        flexDirection={"row"}
        alignItems="center"
        justifyContent="flex-start"
      >
        <Box  w="100%" justifyContent='end' display='flex'>
          <Button
            borderRadius="10px"
            padding="12px 30px"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            bg={"rgba(255, 255, 255, 1)"}
            boxShadow={"0px 0px 4px 0px rgba(0, 0, 0, 0.08)"}
            fontFamily="'Roboto', sans-serif"
            fontSize="18px"
            fontWeight="500"
            transition="0.3s"
            color="rgba(0, 0, 0, 1)"
            w="50%"
          >
            Time Shown in <FaAngleDown style={{marginLeft:'15px',marginTop:'5px'}} />
          </Button>
        </Box>
      </Box>
        </Stack>

      {/* mobile version */}  
        <Stack  className="mobile-version" w="100%" flexDirection="row">
        <Box
        gap="0"
        w="100%"
        display="flex"
        flexDirection={"row"}
        alignItems="center"
        justifyContent="space-between"
      >
        <Button
          fontFamily="'Roboto', sans-serif"
          fontSize="14px"
          fontWeight="500"
          bg="rgba(96, 31, 235, 1)"
          borderRadius="10px"
          padding="12px 30px"
          color="rgba(255, 255, 255, 1)"
          boxShadow={"0px 15px 17px 0px rgba(96, 31, 235, 0.17)"}
        >
          All sessions
        </Button>

        <Button
          fontFamily="'Roboto', sans-serif"
          fontSize="14px"
          fontWeight="500"
          bg="rgba(255, 255, 255, 1)"
          borderRadius="10px"
          padding="12px 30px"
          transition="0.3s"
          mx="5px"
          color="rgba(0, 0, 0, 1)"
          boxShadow={"0px 15px 17px 0px rgba(96, 31, 235, 0.17)"}
          _hover={{
            backgroundColor: "rgba(96, 31, 235, 1)",
            color: "rgba(255, 255, 255, 1)",
          }}
        >
          FRX Academic
        </Button>

        <Button
          fontFamily="'Roboto', sans-serif"
          fontSize="14px"
          fontWeight="500"
          bg="rgba(255, 255, 255, 1)"
          borderRadius="10px"
          padding="12px 30px"
          transition="0.3s"
          color="rgba(0, 0, 0, 1)"
          boxShadow={"0px 15px 17px 0px rgba(96, 31, 235, 0.17)"}
          _hover={{
            backgroundColor: "rgba(96, 31, 235, 1)",
            color: "rgba(255, 255, 255, 1)",
          }}
        >
          FRX Pro
        </Button>
      </Box>
        </Stack>
    </VStack>
  );
};

export default Filtering;
